const initialState = true;

function loadingReducer(state = initialState, action) {
  switch (action.type) {
    case "loading/update":
      return action.payload;
    default:
      return state;
  }
}

export default loadingReducer;
